import React, { useState, useEffect } from "react";
import "./App.css";
import { Link } from 'react-router-dom';
import logoImage from './assets/carbon-twelve-7.png';
import ParticleGrid from './ParticleGrid';

function Main() {
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <ParticleGrid />
    <header className="App-header" style={{ position: 'relative', zIndex: 1 }}>
      <div className="terminal-window main-terminal">
        <div className="terminal-header">
          <span className="terminal-title">C12://TERMINAL</span>
          <div className="terminal-controls">
            <span className="terminal-control">_</span>
            <span className="terminal-control">□</span>
            <span className="terminal-control">×</span>
          </div>
        </div>
        <div className="terminal-content">
          <div className="logo-container">
            <img src={logoImage} alt="Carbon Twelve" className="terminal-logo" />
            <div className="logo-scanline"></div>
          </div>
          <p className="terminal-line center">
            <span className="terminal-highlight">CARBON TWELVE</span>
          </p>
          <p className="terminal-line center">
            Web3 Product Studio
          </p>
          <div className="terminal-menu">
            <p className="terminal-line">
              <span className="terminal-prompt">$</span> Select an option:
            </p>
            <Link to="/About" className="terminal-menu-item">
              <span className="terminal-prompt">&gt;</span> [1] ABOUT
            </Link>
            <Link to="/blog" className="terminal-menu-item">
              <span className="terminal-prompt">&gt;</span> [2] BLOG
            </Link>
            <a href="https://github.com/Carbon-Twelve-C12/" target="_blank" rel="noopener noreferrer" className="terminal-menu-item">
              <span className="terminal-prompt">&gt;</span> [3] GITHUB
            </a>
          </div>
          <p className="terminal-line">
            <span className="terminal-prompt">$</span> 
            <span className="terminal-cursor">{showCursor ? '_' : ' '}</span>
          </p>
        </div>
      </div>
    </header>
    </>
  );
}

export default Main;